module.exports = "/fonts/vendor/lightgallery/src/lg.woff?1fbfd4bcffccb94e8e8a5ea70616b296";